import React, { useEffect } from "react";
import styled from "styled-components";
import FinanceScoreImage from "../../assets/material-symbols-light_finance.svg";
import HeartImage from "../../assets/solar_health-linear.svg";
import StarImage from "../../assets/material-symbols_asterisk.svg";
import { useNavigate } from "react-router-dom";
const Container = styled.div`
  font-family: sans-serif;
  min-height: 100vh;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
`;

const UpperContainer = styled.div`
  background-color: #f9f4f1;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  justify-content: center;
  padding: 20px;
  margin-bottom: 20px;
  height: 33vh;
`;

const ScoreWrapper = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  width: 100%;
`;

const Heading = styled.h1`
  font-size: 24px;
  font-weight: bold;
  margin-bottom: 15px;
`;

const ScoreCircle = styled.div`
  width: 116px;
  height: 120px;
  border-radius: 50%;
  background: radial-gradient(
    circle,
    rgba(255, 99, 71, 0.5) 50%,
    rgba(255, 99, 71, 0.1) 100%
  );
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 32px;
  color: rgb(255, 255, 255);
  text-align: center;
  flex-direction: column;
`;

const ScoreText = styled.span`
  font-size: 25px;
  font-weight: normal;
  color: rgb(255, 255, 255);
  margin-top: 5px;
`;

const LowerContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 15px;
  align-items: center;
  padding: 0 20px;
`;

const CardsContainer = styled.div`
  display: flex;
  gap: 15px;
  justify-content: center;
  width: 100%;
`;

const Card = styled.div`
  border: 1px solid #ddd;
  padding: 15px;
  border-radius: 10px;
  text-align: left;
  flex: 1;
  min-width: max-content;
  display: flex;
  flex-direction: column;
  position: relative;
`;

const BigCard = styled.div`
  border: 1px solid #ddd;
  padding: 15px;
  border-radius: 10px;
  text-align: left;
  width: 90%;
  max-width: 400px;
  display: flex;
  justify-content: space-between;
  align-items: center;
`;

const IconWrapper = styled.div`
  position: absolute;
  top: 10px;
  left: 10px;
`;

const ScoreWrapperCard = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-top: 20px;
`;

const RiskIconWrapper = styled.div`
  font-size: 24px;
  color: #f4a100;
`;

const ProgressBar = styled.div`
  width: 100%;
  height: 4px;
  background: #e0e0e0;
  position: relative;
  margin-bottom: 20px;
  &::after {
    content: "";
    position: absolute;
    width: 100%;
    height: 100%;
    background: black;
  }
`;

// Styled button at the bottom
const ButtonContainer = styled.div`
  display: flex;
  justify-content: center;
  padding: 20px;
`;

const DoneButton = styled.button`
  background-color:rgb(0, 0, 0);
  color: white;
  border: none;
  padding: 10px 20px;
  font-size: 16px;
  border-radius: 5px;
  cursor: pointer;
  width: 90%;
  max-width: 400px;
  text-align: center;

  &:hover {
    background-color: #0056b3;
  }
`;

const ScoreComponent: React.FC = () => {
  const healthScore = localStorage.getItem("healthScore");

  
  const navigate = useNavigate();

  const finalScore = (Number(healthScore) + 82) / 2;

  const handleDoneClick = () => {
    navigate("/close");
    // Add navigation or other actions here
  };

  return (
    <Container>
      <UpperContainer>
        <ProgressBar />
        <Heading>Score</Heading>
        <ScoreWrapper>
          <div style={{ fontSize: "20px" }}>
            Your Comprehensive <br />
            Insurance Eligibility <br />
            Score is
          </div>
          <ScoreCircle>
            {finalScore}
            <ScoreText>Good</ScoreText>
          </ScoreCircle>
        </ScoreWrapper>
      </UpperContainer>

      <LowerContainer>
        <CardsContainer>
          <Card>
            <IconWrapper>
              <img src={FinanceScoreImage} alt="Finance Score" width="24" />
            </IconWrapper>
            <div style={{ marginTop: "40px", color: "#555" }}>
              Finance Score
            </div>
            <ScoreWrapperCard>
              <div></div>
              <strong>82/100</strong>
            </ScoreWrapperCard>
          </Card>
          <Card>
            <IconWrapper>
              <img src={HeartImage} alt="Health Score" width="24" />
            </IconWrapper>
            <div style={{ marginTop: "40px", color: "#555" }}>Health Score</div>
            <ScoreWrapperCard>
              <div></div>
              <strong>{healthScore}/100</strong>
            </ScoreWrapperCard>
          </Card>
        </CardsContainer>
        <BigCard>
          <div>
            <div
              style={{ fontSize: "16px", color: "#555", marginBottom: "5px" }}
            >
              Risk Category
            </div>
            <span style={{ fontWeight: "bold", fontSize: "20px" }}>
              Moderate Risk
            </span>
          </div>
          <RiskIconWrapper>
            <img src={StarImage} alt="Risk Indicator" width="54" />
          </RiskIconWrapper>
        </BigCard>
      </LowerContainer>

      {/* Done Button at the bottom */}
      <ButtonContainer>
        <DoneButton onClick={handleDoneClick}>Done</DoneButton>
      </ButtonContainer>
    </Container>
  );
};

export default ScoreComponent;
